import { connect } from 'react-redux';
import Landing from '../../../components/views/Landing';
import { isStorageAvailable } from '../../../modules/app/selectors';
import { link } from '../../../modules/analytics/actions';

const mapDispatchToProps = {
  clickLink: link,
};

const mapStateToProps = state => ({
  storageAvailable: isStorageAvailable(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
